module.exports = __webpack_public_path__ + "static/media/record.9cea2e8c.wav";